export default "__VITE_ASSET__BKzOKptB__"